export const SERVICES = [
  {
    id: "risk-evaluation",
    num: "01",
    title: "Culture Assessment",
    short: "Through our unique and efficient approach we examine existing attitudes and behaviours from senior management to your frontline.",
    image: "/assets/culture-assessment.jpg",
    icon: "/assets/icon-culture-assessment.png",
    alt: "Safety engineers reviewing hazard mapping on site",
    points: [
      "Confidential appraisal of existing attitudes and behaviours across every level of the organisation",
      "One to one interviews from accomplished performance coaches who build instant trust and rapport",
      "An evaluation of those systems and procedures that may be impacting attitudes and driving the wrong behaviours",
      "A review of those incidents and near misses that highlight where behaviour is deviating from the critical standards required",
    ],
    detail:
      "Before behaviour can change, you need to know what people truly believe and why. We uncover the gap between corporate procedures and expectations and the reality of behaviour from the Boardroom to the frontline - the shortcuts, the misperceptions, the risks nobody reports and the attitudes nobody says out loud. We help you clearly understand where the lines have become blurred between capability and motivation.",
  },
  {
    id: "actor-led-workshops",
    num: "02",
    title: "Bespoke Workshops",
    short: "We are experienced consultants with acting skills and we can guarantee changes in attitudes through our tailored workshops. Reflecting the reality of your workplace for everyone.",
    image: "/assets/workshop-bespoke.jpg",
    icon: "/assets/icon-bespoke-workshops.png",
    alt: "Actor-led workshop engaging a team on safety culture",
    points: [
      "Our team are consultants who are also professional actors and they build scenarios from your real incidents",
      "Stop-the-scene facilitation — delegates direct the action and test choices",
      "Where a culture assessment has been done we will interweave those findings into your workshops",
      "Emotionally memorable learning that outlasts any slide deck",
    ],
    detail:
      "Some things live short in the memory but people never forget seeing something real that happened in their organisation brought to life in front of them. Using language they recognise and situations they are familiar with our consultant-actor led workshops put your managers and operatives inside the drama of their own decisions. We guarantee you will be delighted with the power and impact this has to launch your culture change programme.",
  },
  {
    id: "performance-management",
    num: "03",
    title: "Optimised Performance Management",
    short: "We understand what drives performance whether it is safety or productivity and we will help you shape your processes to drive the right behaviours and achieve the right outcomes.",
    image: "/assets/performance-management-new.png",
    icon: "/assets/icon-performance-management.png",
    alt: "Performance management impact on safety attitudes diagram",
    points: [
      "What constitute the performance critical behaviours for your organisation, especially around safety ?",
      "Ensure that leading indicators which are both behaviour and risk based are prominent in measured performance",
      "Review and ensure the presence of a \"just and fair\" culture",
      "Ensure that proper root cause analysis identifies systemic failings that have driven poor behaviours at every level",
    ],
    detail:
      "Understanding the nature of the problem is one thing and engaging everyone through powerful workshops is another. However for things to truly \"stick\" and changed attitudes to become positive habits we need more. This is where our knowledge of Performance Management becomes critical. We will help you understand where important elements of your business management may be driving the wrong behaviours and reinforcing unhelpful attitudes",
  },
];

export const SECTORS = ["Rail & Infrastructure", "Waste Management", "Energy & Utilities", "Oil & Gas", "Construction", "Nuclear", "Manufacturing", "FMCG"];

export const CLIENT_LOGOS = [
  { name: "Coca-Cola", src: "/assets/logo-cocacola.png" },
  { name: "Eaton", src: "/assets/logo-eaton.png" },
  { name: "General Electric", src: "/assets/logo-ge.png" },
  { name: "ACWA Power", src: "/assets/logo-acwa.png" },
  { name: "KAEFER", src: "/assets/logo-kaefer.png" },
  { name: "Severfield", src: "/assets/logo-severfield.png" },
  { name: "Balfour Beatty", src: "/assets/logo-balfour.png" },
  { name: "GSK", src: "/assets/logo-gsk.png" },
  { name: "Alstom", src: "/assets/logo-alstom.png" },
  { name: "Dubai Petroleum", src: "/assets/logo-dubai-petroleum.png" },
  { name: "ConocoPhillips", src: "/assets/logo-conocophillips.png" },
  { name: "UK Atomic Energy Authority", src: "/assets/logo-ukaea.png" },
  { name: "Hitachi Energy", src: "/assets/logo-hitachi.png" },
  { name: "William Hare", src: "/assets/logo-hare.png" },
  { name: "Bühler", src: "/assets/logo-buhler.png" },
  { name: "Scottish Water", src: "/assets/logo-scottish-water.png" },
  { name: "Binnies", src: "/assets/logo-binnies.png" },
  { name: "Carlsberg", src: "/assets/logo-carlsberg.png" },
  { name: "Atkins", src: "/assets/logo-atkins.png" },
  { name: "Keepmoat", src: "/assets/logo-keepmoat.png" },
  { name: "Siemens Gamesa", src: "/assets/logo-siemens-gamesa.png" },
  { name: "Rolls-Royce", src: "/assets/logo-rolls-royce.png" },
  { name: "Maersk", src: "/assets/logo-maersk.png" },
  { name: "Avgol", src: "/assets/logo-avgol.png" },
  { name: "Schlumberger", src: "/assets/logo-schlumberger.png" },
  { name: "Accelleron", src: "/assets/logo-accelleron.png" },
  { name: "Black & Veatch", src: "/assets/logo-blackveatch.png" },
  { name: "Bilfinger", src: "/assets/logo-bilfinger.png" },
  { name: "DS Smith", src: "/assets/logo-dssmith.png" },
  { name: "ALTRAD", src: "/assets/logo-altrad.png" },
  { name: "St. Modwen", src: "/assets/logo-stmodwen.png" },
  { name: "Crossrail", src: "/assets/logo-crossrail.png" },
  { name: "E.ON", src: "/assets/logo-eon.png" },
  { name: "Klöckner Metals", src: "/assets/logo-kloeckner.png" },
  { name: "NICO International", src: "/assets/logo-nico.png" },
  { name: "Amey", src: "/assets/logo-amey.png" },
  { name: "VINCI", src: "/assets/logo-vinci.png" },
  { name: "Biffa", src: "/assets/logo-biffa.png" },
];

export const CASE_STUDIES = [
  {
    sector: "Construction",
    title: "Using leadership and a zero deviation plan to eliminate serious accidents",
    client: "Global Construction Business now part of GE",
    image: "/assets/case-energy.jpg",
    logo: "/assets/logo-alstom.png",
    video: "/assets/alstom-safety-leadership.mp4",
    videoWebm: "/assets/alstom-safety-leadership.webm",
    videoPoster: "/assets/alstom-video-poster.jpg",
    problem: "Alstom Power building and maintaining power stations around the globe without serious injury through exemplar leadership and the Alstom Zero Deviation Plan (AZDP)",
    intervention: "Assessed the existing safety culture to create a global Safety Leadership Programme, embedding safety coaching skills throughout and reengineered key processes and policies to adopt a zero tolerance approach to deviations from Alstom's Life Saving Rules. Across 45 different countries.",
    result: "Dramatic improvement to compliance with Life Saving Rules and proactive coaching from Alstom's leadership at every level. The creation of a 'Just' and 'Fair' culture around safety critical behaviours.",
    resultHighlight: "Significant reduction in serious injuries. £Millions of loss prevented.",
    metric: "100%",
    metricLabel: "adherence to Alstom's Life Saving Rules",
  },
  {
    sector: "Water Utilities",
    title: "Safety coaching and leadership to drive 100% Behaviour On Safe Sites",
    client: "",
    image: "/assets/case-binnies.jpg",
    logo: "/assets/logo-binnies.png",
    video: "/assets/boss-safety-coaching.mp4",
    videoWebm: "/assets/boss-safety-coaching.webm",
    videoPoster: "/assets/boss-video-poster.jpg",
    problem: "A programme was required to drive a \"safety first\" culture in a \"can-do\" organisation.",
    intervention: "A UK wide safety culture assessment led to the design of \"BOSS, Behaviour On Safe Sites\" with the creation of trained safety coaches and BOSS champions. This was coupled with a strong focus on SMART safety leadership commitments created during the workshops. BOSS has since developed into ENGAGED following acquisition of B&V UK by RSK Group (reverting to historical brand Binnies). ENGAGED applies the principles of BOSS and more to all elements of successful business performance.",
    result: "Over a 10 year period loss incidents steadily reduced from 280 to 10, a 96% reduction and the elimination of service strikes. Clearly defined and measured behaviours with consistent performance feedback",
    resultHighlight: "96%",
    resultImage: "/assets/boss-graph.jpg",
    metric: "100%",
    metricLabel: "safety critical behaviours",
  },
  {
    sector: "Structural Steel Manufacturing & Engineering",
    title: "Taking safe behaviours out into the factories and projects",
    client: "Steel fabrication, engineering and construction",
    image: "/assets/case-severfield.jpg",
    logo: "/assets/logo-severfield.png",
    video: "/assets/severfield-video.mp4",
    videoPoster: "/assets/severfield-video-poster.jpg",
    problem: "Severfield had delivered an extensive 'behavioural safety' training programme but were not seeing the impact on the ground. This had to change.",
    intervention: "Severfield identified key influential employees across their UK operations and we were able to take them through a coaching development programme that took behavioural safety out of the classroom and into the workplace, reducing risk and driving down incidents.",
    result: "Over a 4 year period every lag indicator showing significant improvement.\n- RIDDOR events down from 18 to 8\n- Minor injuries down from 262 to 147\n- Near miss events down from 491 to 297.\nAll achieved during an exceptionally busy 4 year period.",
    resultHighlight: "Over 120 trained and skill developed coaches working across the business to encourage safety critical behaviours",
    metric: "120+",
    metricLabel: "trained safety coaches across the business",
  },
  {
    sector: "Energy and Water Desalination",
    title: "Changing attitudes to safety",
    client: "Global utility developer and operator",
    image: "/assets/case-acwa.jpg",
    logo: "/assets/logo-acwa-card.png",
    problem: "The client was frustrated with complacent attitudes towards safety that were being shown from management to operative level. The challenge was to identify those attitudes and change them!",
    intervention: "In discussion with ACWA Power senior management we identified the common attitudes that were being expressed through interview and accident analysis. We then developed a workshop programme aimed specifically at challenging them through explaining the science behind their formation and gaining ownership and recognition of the danger of complacent attitudes from every participant",
    result: "Senior Leader 53% average positive shift in attitude. Middle Managers 65% average positive shift. Frontline Leaders 56% average positive shift",
    resultHighlight: "53-65% positive shift",
    metric: "53-65%",
    metricLabel: "positive shift in attitude",
  },
];

export const TESTIMONIALS = [
  {
    quote: "I have excellent experience working with ARMS who have brought to us a sound methodology in terms of behavioural change. ARMS are working with us on future development and their expertise is invaluable. They are also competent trainers and advisors on things related to EHS performance and behaviour. ARMS are very easy to work with at all levels.",
    name: "Glynn Carty",
    org: "Director EMEA, Eaton plc",
    orgNote: "(Previously with Alstom Power)",
    logo: "/assets/logo-eaton.png",
    logoAlt: "Eaton logo",
  },
  {
    quote: "We have had a long relationship with ARMS Ltd, the team are very professional and have significant experience and knowledge of implementing change programmes. I have found ARMS different to other organisations in its approach, they are interested in understanding our business and most importantly understanding our people. From their established knowledge base the ARMS team was able to steer us and ensure that we implemented a successful behavioural scheme (called BOSS) that fits us well and is grounded in behavioural science. We would not have progressed so far and seen the results we have since BOSS was launched without the support and dedication of ARMS.",
    name: "Ruth Powell",
    org: "Safety Manager, Europe, Binnies",
    logo: "/assets/logo-binnies.png",
    logoAlt: "Binnies logo",
  },
  {
    quote: "I was delighted to have appointed ARMS to support the roll-out of our Safety Improvement Programme, they were facing some stiff competition but were best able to demonstrate a cultural fit with our organisation and I immediately felt comfortable working with them. Their professional advice and detailed, technical support have been invaluable and they have impressed everyone they have dealt with. Equally comfortable working with people at all levels in the organisation, from front line operative to CEO, their personal style makes working with them a real pleasure. Very highly recommended!",
    name: "Gary Carvell",
    org: "Group H&S Director, Biffa",
    logo: "/assets/logo-biffa.png",
    logoAlt: "Biffa logo",
  },
  {
    quote: "ARMS supported the review and relaunch of our positive safety culture programme. This was a comprehensive review of recent incidents and interviews with various employees of the business, from shop floor through to board director level, in order to create bespoke presentations aimed at workforce level and leadership level engagement. The end result was a very engaging programme that managed to capture the attention at all levels with positive interaction rolled out to over one thousand people engaged in the manufacturing, construction and management of these activities. The programme in addition to some leading indicator enhancements has contributed to a reduction in the AFR for the business of over 50% in the first year after the rollout. We continue to work with ARMS, capturing new people to the business, including our supply chain and clients alike, all of which find refreshing due to the level of interactive engagement of the workshops.",
    name: "Brian Hughes",
    org: "SHE Director, William Hare Group Ltd",
    logo: "/assets/logo-hare.png",
    logoAlt: "William Hare logo",
  },
];

export const TEAM = [
  {
    name: "Marie Tucker",
    role: "Director",
    bio: "Experienced educator with 21 years as Director of ARMS Ltd",
    image: "/assets/team-marie.jpg",
    imgPos: "object-top",
  },
  {
    name: "John Tucker",
    role: "Senior Consultant",
    bio: "Behavioural scientist with 30 years of working internationally",
    image: "/assets/team-john-v9.jpg",
    imgPos: "object-top",
    linkedin: "https://www.linkedin.com/in/john-tucker-8a509b18/",
  },
  {
    name: "Charlotte",
    role: "Administration and Culture Assessment",
    bio: "Currently studying Forensic Psychology and assisting part time since 2023",
    image: "/assets/team-charlotte-v3.jpg",
    imgPos: "object-top",
  },
  {
    name: "Meadow",
    role: "Administration and Culture Assessment",
    bio: "Currently studying Psychology and assisting part time since 2023",
    image: "/assets/team-meadow-v4.jpg",
    imgPos: "object-top",
  },
];

export const HERO_IMAGE = "/assets/hero-main.jpg";
export const ABOUT_IMAGE = "https://images.unsplash.com/photo-1581094480465-4e6c25fb4a52?crop=entropy&cs=srgb&fm=jpg&q=85";
export const APPROACH_IMAGE = "https://images.pexels.com/photos/18999282/pexels-photo-18999282.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
